/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
const info = (message?: any, optionalParams?: any[]): void => {
  optionalParams
    ? console.info(message, optionalParams)
    : console.info(message);
};

const error = (message?: any, optionalParams?: any[]) => {
  optionalParams
    ? console.error(message, optionalParams)
    : console.error(message);
};

const log = (message?: any, optionalParams?: any[]) => {
  optionalParams ? console.log(message, optionalParams) : console.log(message);
};

const warn = (message?: any, optionalParams?: any[]) => {
  optionalParams
    ? console.warn(message, optionalParams)
    : console.warn(message);
};
const debug = (message?: any, optionalParams?: any[]) => {
  optionalParams
    ? console.debug(message, optionalParams)
    : console.debug(message);
};

export default { info, error, log, warn, debug };
